import { Instagram } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Menciones({ datos, seccion }) {
  const menciones = datos.menciones || [];
  if (menciones.length === 0) return null;

  return (
    <section className="ba-seccion" aria-label={seccion.titulo}>
      <div className="ba-seccion-interior">
        <EncabezadoSeccion p="ba" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ba-titulo-menciones" />
        <div className="ba-menciones">
          {menciones.map((m, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <figure className="ba-mencion" data-testid={`ba-mencion-${i}`}>
                <img className="ba-mencion-foto" src={m.foto} alt={`Fotografía de ${m.nombre}`} loading="lazy" />
                <figcaption>
                  <p className="ba-mencion-nombre">{m.nombre}</p>
                  <p className="ba-mencion-rol">{m.rol}</p>
                  {m.instagramUrl && (
                    <a
                      className="ba-mencion-ig"
                      href={m.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Instagram de ${m.nombre}`}
                      data-testid={`ba-enlace-instagram-${i}`}
                    >
                      <Instagram strokeWidth={1.5} />
                    </a>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
